import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

const apiUrl = environment.rapi;
const specialCountries = [272, 281, 305];

@Injectable({
  providedIn: 'root'
})
export class StateService {
  countryID: number;

  constructor(private _http: HttpClient) {}

  countryHasState(): any {
    let hasState = specialCountries.find((sc) => sc == this.countryID);
    if (Number(hasState)) {
      return true;
    }
    return false;
  }

  getStates(): any {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Accept: 'application/json'
      }
    };
    return this._http.get(`${apiUrl}/api/countries/states/${this.countryID}`, httpOptions);
  }
}
